import { HelmetProvider } from "react-helmet-async";

import { readAppEnv } from "@/lib/env";
import type { AnalyticsConfig } from "@/modules/analytics";
import { AnalyticsProvider } from "@/modules/analytics";
import { AppRoutes } from "@/routes";

function buildAnalyticsConfig(): AnalyticsConfig {
  try {
    const env = readAppEnv();
    return {
      cloudflareToken: env.cloudflareAnalyticsToken,
      enabled: env.enableAnalytics,
      plausibleDomain: env.plausibleDomain,
    };
  } catch {
    return { enabled: false };
  }
}

const analyticsConfig = buildAnalyticsConfig();

export default function App(): JSX.Element {
  return (
    <HelmetProvider>
      <AnalyticsProvider config={analyticsConfig}>
        <AppRoutes />
      </AnalyticsProvider>
    </HelmetProvider>
  );
}
